var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("encryption-field", {
    attrs: {
      "field-name": _vm.fieldName,
      "encrypted-value": _vm.value,
      label: _vm.label,
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var revealed = ref.value
          return [
            !_vm.urls(revealed).length
              ? _c("span", [_vm._v("********")])
              : _vm._e(),
            _vm._l(_vm.urls(revealed), function (url, index) {
              return _c(
                "a",
                {
                  key: url,
                  attrs: {
                    href: url,
                    target: "_blank",
                    rel: "noopener noreferrer",
                  },
                },
                [_vm._v(_vm._s(_vm.label) + " " + _vm._s(index + 1))]
              )
            }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }